import { DemographicValueModel } from '../demographics/demographic-value-model' ;

export interface SurveyUserDetailsModel {
  firstName: string;
  lastName: string;
  demographicValues: DemographicValueModel[];
}
